const pageFunctions: Record<string, () => void> = {};
export const addPageFunction = (pageName: string, pageFunction: () => void) => {
  pageFunctions[pageName] = pageFunction;
};
export const getPageFunction = (pageName: string) => {
  return pageFunctions[pageName];
};